(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-mamourse-byb]';

  function number(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function bool(value) {
    return String(value).toLowerCase() === 'true';
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function token(text, key, value) {
    return String(text || '').split(key).join(String(value));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cleanVariantTitle(value) {
    value = String(value || '').trim();
    return value.toLowerCase() === 'default title' ? '' : value;
  }

  function formatMoney(cents) {
    var amount = Math.round(number(cents, 0)) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function readVariant(card) {
    var select = card.querySelector('[data-mamourse-variant-select]');
    if (!select) return null;

    var option = select.options[select.selectedIndex];
    if (!option) return null;

    var options = [
      option.dataset.option1,
      option.dataset.option2,
      option.dataset.option3
    ].map(function (value) {
      return String(value || '').trim();
    }).filter(function (value) {
      return value && value.toLowerCase() !== 'default title';
    });

    return {
      id: number(option.value, 0),
      title: cleanVariantTitle(option.dataset.title),
      price: Math.round(number(option.dataset.price, 0)),
      compareAt: Math.round(number(option.dataset.compare, 0)),
      available: String(option.dataset.available).toLowerCase() === 'true',
      image: String(option.dataset.image || card.dataset.productImage || ''),
      options: options
    };
  }

  function syncCardVariant(root, card) {
    var variant = readVariant(card);
    if (!variant) return;

    var price = card.querySelector('[data-mamourse-card-price]');
    var compare = card.querySelector('[data-mamourse-card-compare]');
    var button = card.querySelector('[data-mamourse-add]');
    var buttonText = button ? button.querySelector('span') : null;
    var image = card.querySelector('.mamourse-byb__product-image');

    if (price) {
      price.textContent = formatMoney(variant.price);
    }

    if (compare) {
      if (variant.compareAt > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(variant.compareAt);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    if (button) {
      button.disabled = !variant.available;
    }

    if (buttonText) {
      buttonText.textContent = variant.available ? root.dataset.addText : root.dataset.soldOutText;
    }

    if (image && variant.image) {
      image.src = variant.image;
    }
  }

  function getCardQuantity(root, card) {
    if (!bool(root.dataset.showQuantity)) return 1;

    var input = card.querySelector('[data-mamourse-qty-input]');
    if (!input) return 1;

    var max = Math.max(1, number(root.dataset.maxProductQuantity, 9));
    return clamp(Math.round(number(input.value, 1)), 1, max);
  }

  function initQuantity(root, card) {
    var input = card.querySelector('[data-mamourse-qty-input]');
    if (!input) return;

    var minus = card.querySelector('[data-mamourse-qty-minus]');
    var plus = card.querySelector('[data-mamourse-qty-plus]');
    var max = Math.max(1, number(root.dataset.maxProductQuantity, 9));

    function set(value) {
      input.value = clamp(Math.round(number(value, 1)), 1, max);
    }

    if (minus) {
      minus.addEventListener('click', function () {
        set(number(input.value, 1) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        set(number(input.value, 1) + 1);
      });
    }

    input.addEventListener('change', function () {
      set(input.value);
    });
  }

  function initSection(root) {
    if (!root || root.dataset.mamourseBasketReady === 'true') return;
    root.dataset.mamourseBasketReady = 'true';

    var selectedItems = [];
    var tierButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mamourse-tier]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mamourse-product-card]'));

    var selected = root.querySelector('[data-mamourse-selected]');
    var progress = root.querySelector('[data-mamourse-progress]');
    var subtotal = root.querySelector('[data-mamourse-subtotal]');
    var savingsRow = root.querySelector('[data-mamourse-savings-row]');
    var savings = root.querySelector('[data-mamourse-savings]');
    var total = root.querySelector('[data-mamourse-total]');
    var addBundle = root.querySelector('[data-mamourse-add-bundle]');
    var message = root.querySelector('[data-mamourse-message]');

    var activeTier = null;

    function showMessage(text, error) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.toggle('is-error', Boolean(error));
    }

    function getTier(button) {
      if (!button) return null;

      var mode = String(button.dataset.mode || 'fixed');
      var min = Math.max(1, number(button.dataset.min, 1));
      var max = Math.max(min, number(button.dataset.max, min));

      if (mode === 'fixed') max = min;
      if (mode === 'open') max = Infinity;

      return {
        button: button,
        mode: mode,
        min: min,
        max: max,
        discountPercent: clamp(number(button.dataset.discountPercent, 0), 0, 100),
        discountCode: String(button.dataset.discountCode || '').trim()
      };
    }

    function selectedCount() {
      return selectedItems.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
    }

    function selectedSubtotal() {
      return selectedItems.reduce(function (sum, item) {
        return sum + (item.price * item.quantity);
      }, 0);
    }

    function eligible(tier, count) {
      if (!tier) return false;
      if (tier.mode === 'fixed') return count === tier.min;
      if (tier.mode === 'range') return count >= tier.min && count <= tier.max;
      return count >= tier.min;
    }

    function capacity(tier, count) {
      if (!tier) return 0;
      if (tier.mode === 'open') return Infinity;
      return Math.max(0, tier.max - count);
    }

    function slotCount(tier, count) {
      if (!tier) return 0;
      if (tier.mode === 'fixed') return tier.min;
      if (tier.mode === 'range') return Math.min(tier.max, Math.max(tier.min, count));
      return Math.max(tier.min, count);
    }

    function unitList() {
      var units = [];

      selectedItems.forEach(function (item) {
        for (var i = 0; i < item.quantity; i += 1) {
          units.push({
            key: item.key,
            title: item.title,
            variantTitle: item.variantTitle,
            image: item.image
          });
        }
      });

      return units;
    }

    function removeOne(key) {
      var index = selectedItems.findIndex(function (item) {
        return item.key === key;
      });

      if (index < 0) return;

      if (selectedItems[index].quantity > 1) {
        selectedItems[index].quantity -= 1;
      } else {
        selectedItems.splice(index, 1);
      }

      showMessage('', false);
      update();
    }

    function renderSlots(tier, count) {
      if (!selected) return;

      var slots = slotCount(tier, count);
      var units = unitList();
      var html = '';

      for (var i = 0; i < slots; i += 1) {
        var unit = units[i];

        if (unit) {
          html +=
            '<div class="mamourse-byb__slot">' +
              (unit.image
                ? '<img src="' + escapeHtml(unit.image) + '" alt="" class="mamourse-byb__slot-image" loading="lazy">'
                : '<div class="mamourse-byb__slot-placeholder">🧸</div>') +
              '<div class="mamourse-byb__slot-info">' +
                '<div class="mamourse-byb__slot-title">' + escapeHtml(unit.title) + '</div>' +
                (unit.variantTitle
                  ? '<div class="mamourse-byb__slot-variant">' + escapeHtml(unit.variantTitle) + '</div>'
                  : '') +
              '</div>' +
              '<button type="button" class="mamourse-byb__remove" data-mamourse-remove="' + escapeHtml(unit.key) + '" aria-label="Remove one item">✕</button>' +
            '</div>';
        } else {
          html +=
            '<div class="mamourse-byb__slot is-empty">' +
              '<div class="mamourse-byb__slot-placeholder">🧸</div>' +
              '<div class="mamourse-byb__slot-info">' +
                '<div class="mamourse-byb__slot-title">' + escapeHtml(root.dataset.emptySlotTitle) + '</div>' +
                '<div class="mamourse-byb__slot-variant">' + escapeHtml(root.dataset.emptySlotText) + '</div>' +
              '</div>' +
            '</div>';
        }
      }

      selected.innerHTML = html;

      Array.prototype.slice.call(selected.querySelectorAll('[data-mamourse-remove]')).forEach(function (button) {
        button.addEventListener('click', function () {
          removeOne(button.getAttribute('data-mamourse-remove'));
        });
      });
    }

    function renderProgress(tier, count) {
      if (!progress || !tier) return;

      var ready = eligible(tier, count);
      progress.classList.toggle('is-ready', ready);

      if (ready) {
        progress.textContent = root.dataset.readyText;
        return;
      }

      var remaining = Math.max(0, tier.min - count);
      var text = token(root.dataset.pickMoreText, '[count]', remaining);
      text = token(text, '[suffix]', remaining === 1 ? '' : 's');
      progress.textContent = text;
    }

    function renderTotals(tier) {
      var rawSubtotal = selectedSubtotal();
      var discount = tier ? Math.round(rawSubtotal * (tier.discountPercent / 100)) : 0;
      var finalTotal = Math.max(0, rawSubtotal - discount);

      if (subtotal) subtotal.textContent = formatMoney(rawSubtotal);
      if (savings) savings.textContent = '-' + formatMoney(discount);
      if (total) total.textContent = formatMoney(finalTotal);

      if (savingsRow) {
        savingsRow.hidden = !tier || tier.discountPercent <= 0 || rawSubtotal <= 0;
      }
    }

    function update() {
      var count = selectedCount();

      renderSlots(activeTier, count);
      renderProgress(activeTier, count);
      renderTotals(activeTier);

      if (addBundle) {
        addBundle.disabled = !eligible(activeTier, count);

        if (addBundle.dataset.busy !== 'true') {
          addBundle.textContent = root.dataset.addBundleText;
        }
      }
    }

    function activateTier(button) {
      activeTier = getTier(button);

      tierButtons.forEach(function (tierButton) {
        var isActive = tierButton === button;
        tierButton.classList.toggle('is-active', isActive);
        tierButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (activeTier && activeTier.mode !== 'open' && selectedCount() > activeTier.max) {
        var remaining = activeTier.max;
        var trimmed = [];

        selectedItems.forEach(function (item) {
          if (remaining <= 0) return;

          var quantity = Math.min(item.quantity, remaining);

          if (quantity > 0) {
            trimmed.push(Object.assign({}, item, { quantity: quantity }));
            remaining -= quantity;
          }
        });

        selectedItems = trimmed;
      }

      showMessage('', false);
      update();
    }

    function addSelection(card) {
      if (!activeTier) return;

      var variant = readVariant(card);

      if (!variant || !variant.available) {
        showMessage(root.dataset.soldOutText, true);
        return;
      }

      var quantity = getCardQuantity(root, card);
      var remaining = capacity(activeTier, selectedCount());

      if (remaining !== Infinity && remaining <= 0) {
        showMessage(root.dataset.basketFullText, true);
        return;
      }

      if (remaining !== Infinity && quantity > remaining) {
        var text = token(root.dataset.quantityExceedsText, '[count]', remaining);
        text = token(text, '[suffix]', remaining === 1 ? '' : 's');
        showMessage(text, true);
        return;
      }

      var existing = selectedItems.some(function (item) {
        return item.variantId === variant.id;
      });

      if (existing) {
        showMessage(root.dataset.duplicateText, true);
        return;
      }

      selectedItems.push({
        key: String(variant.id),
        variantId: variant.id,
        title: String(card.dataset.productTitle || 'Mamourse Product'),
        variantTitle: variant.title,
        variantOptions: variant.options,
        price: variant.price,
        image: variant.image || String(card.dataset.productImage || ''),
        quantity: quantity
      });

      showMessage('', false);
      update();
    }

    function addBundleToMamourseHeader() {
      if (!activeTier || !eligible(activeTier, selectedCount()) || !addBundle) {
        update();
        return;
      }

      if (typeof window.addToCart !== 'function') {
        showMessage(root.dataset.headerMissingText, true);
        return;
      }

      if (activeTier.discountCode) {
        if (typeof window.applyBundleDiscount !== 'function') {
          showMessage(root.dataset.headerMissingText, true);
          return;
        }

        var discountAccepted = window.applyBundleDiscount(activeTier.discountCode);

        if (discountAccepted === false) {
          showMessage('This bundle discount code is not configured in the Mamourse header.', true);
          return;
        }
      }

      addBundle.dataset.busy = 'true';
      addBundle.disabled = true;
      addBundle.textContent = root.dataset.addingText;
      showMessage('', false);

      try {
        selectedItems.forEach(function (item) {
          window.addToCart({
            variant_id: Number(item.variantId),
            title: item.title,
            price: item.price / 100,
            quantity: item.quantity,
            image: item.image || '',
            variant_title: item.variantTitle || '',
            variant_options: item.variantOptions || []
          });
        });

        selectedItems = [];
        addBundle.textContent = root.dataset.addedText;
        update();

        window.setTimeout(function () {
          addBundle.dataset.busy = 'false';
          addBundle.textContent = root.dataset.addBundleText;
          update();
        }, 1200);
      } catch (error) {
        console.error('Mamourse bundle add error:', error);
        addBundle.dataset.busy = 'false';
        addBundle.textContent = root.dataset.addBundleText;
        showMessage(root.dataset.headerMissingText, true);
        update();
      }
    }

    cards.forEach(function (card) {
      initQuantity(root, card);
      syncCardVariant(root, card);

      var select = card.querySelector('[data-mamourse-variant-select]');
      var button = card.querySelector('[data-mamourse-add]');

      if (select) {
        select.addEventListener('change', function () {
          syncCardVariant(root, card);
        });
      }

      if (button) {
        button.addEventListener('click', function () {
          addSelection(card);
        });
      }
    });

    tierButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTier(button);
      });
    });

    if (addBundle) {
      addBundle.addEventListener('click', addBundleToMamourseHeader);
    }

    var defaultTier = tierButtons.find(function (button) {
      return String(button.dataset.default).toLowerCase() === 'true';
    }) || tierButtons[0] || null;

    if (defaultTier) {
      activateTier(defaultTier);
    } else {
      update();
    }
  }

  function scan(scope) {
    scope = scope || document;

    Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  window.MamourseBundleBuilder = {
    scan: scan
  };
})();
